module.exports = __webpack_public_path__ + "static/media/services4.c3b5c3f3.png";